import { FormInput } from 'src/components/FormInput';
import { FormProvider } from 'src/components/FormProvider';

import styles from './EmailSubmitForm.module.scss';
import { useForm } from 'react-hook-form';
import { Button } from 'src/v2/commonComponents/Button';
import { CheckCircle } from '@phosphor-icons/react';
import { SVG_SIZE_S } from 'src/constants';
import { isIOS } from 'react-device-detect';
import cn from 'classnames';

type EmailSubmitFormProps = {
  buttonText?: string;
  onSubmit: (email: string) => Promise<void> | void;
  errorMessage?: string | React.ReactNode;
  defaultEmail?: string;
};

enum SignupFields {
  EMAIL = 'email',
}

interface FormData {
  [SignupFields.EMAIL]: string;
}

export const EmailSubmitForm = ({
  onSubmit,
  errorMessage,
  buttonText = 'Continue',
  defaultEmail,
}: EmailSubmitFormProps) => {
  const methods = useForm<FormData>({
    defaultValues: {
      [SignupFields.EMAIL]: defaultEmail || '',
    },
  });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const submitForm = async (formData: FormData) => {
    await onSubmit(formData[SignupFields.EMAIL].toLowerCase());
  };

  const showLastUsedLabel = !!defaultEmail;

  return (
    <FormProvider<FormData> methods={methods}>
      <form onSubmit={handleSubmit(submitForm)} className={styles.root}>
        <div className={styles.wrapper}>
          <FormInput
            name={SignupFields.EMAIL}
            type="email"
            className={cn(
              styles.email,
              isIOS && styles.iosPatch,
              showLastUsedLabel && styles.focused,
            )}
            placeholder="Email Address"
            required={true}
            errorMessage={errorMessage}
          />
          {showLastUsedLabel && (
            <span className={styles.lastUsedLabel}>
              <CheckCircle size={SVG_SIZE_S} weight="fill" />
              Last used to login
            </span>
          )}
        </div>
        <Button type="submit" color="highlight" disabled={isSubmitting}>
          <span>{buttonText}</span>
        </Button>
      </form>
    </FormProvider>
  );
};
